export default {
      id: "left-arrow-back-usage",
      viewBox: "0 0 13 23",
      url: __webpack_public_path__ + "img/icons.df848786.svg#left-arrow-back",
      toString: function () {
        return this.url;
      }
    }